var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:(_vm.item.width?'width:'+_vm.item.width:'')},[_c('img',{attrs:{"src":_vm.item.url,"alt":""}}),( +new Date() < +new Date(_vm.item.endTime))?_c('van-notice-bar',{attrs:{"left-icon":"volume-o","text":_vm.item.msg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }